export default (fieldName, value, functions) => {
  console.log(0, value)
  functions.setFieldTouched(fieldName, true)
  functions.setFieldValue(fieldName, value)
}
